import React from 'react';
import { ArrayFieldTitleProps } from '@rjsf/utils';
import { Header } from '../../components';

/**
 * Reders the title of the template.
 * @see https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-templates/#arrayfieldtitletemplate
 * @param props ArrayFieldTitleProps
 * @returns Layout of the Title.
 */
const ArrayFieldTitleTemplate = (props: ArrayFieldTitleProps) => {
  const { title } = props;
  return <Header data-testid="HeaderTestId" title={title!} />;
};

export default ArrayFieldTitleTemplate;
